import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  Typography,
  Box,
} from '@mui/material';
import {
  Share as ShareIcon,
  ContentCopy as ContentCopyIcon,
  OpenInNew as OpenInNewIcon,
} from '@mui/icons-material';

/**
 * Dialog de Compartilhamento de schedule Pública
 */
export default function ShareAgendaDialog({ open, onClose, shareUrl, onCopy, onOpen }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ShareIcon color="primary" />
          <Typography variant="h6" component="span">
            Compartilhar Agenda Pública
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: 600 }}>
            🎯 Principais funcionalidades do link público
          </Typography>
          <Typography variant="body2" paragraph>
            Este é o link da sua <strong>agenda pública de agendamento</strong>. Ao compartilhá-lo, 
            seus clientes poderão visualizar os horários disponíveis e realizar agendamentos de forma 
            totalmente autônoma, sem necessidade de contato prévio!
          </Typography>
          
          <Typography variant="body1" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
            📱 Onde você pode compartilhar
          </Typography>
          <Box component="ul" sx={{ mt: 1, mb: 2, pl: 2 }}>
            <li><Typography variant="body2">✓ Bio do Instagram, TikTok e outras redes sociais</Typography></li>
            <li><Typography variant="body2">✓ Descrição do perfil de WhatsApp Business</Typography></li>
            <li><Typography variant="body2">✓ Website ou blog pessoal/profissional</Typography></li>
            <li><Typography variant="body2">✓ Assinatura de e-mail profissional</Typography></li>
            <li><Typography variant="body2">✓ Mensagens diretas e grupos de WhatsApp</Typography></li>
            <li><Typography variant="body2">✓ Stories, posts e anúncios nas redes sociais</Typography></li>
            <li><Typography variant="body2">✓ QR Code impresso em cartões de visita e materiais de divulgação</Typography></li>
          </Box>

          <Typography variant="body1" gutterBottom sx={{ fontWeight: 600 }}>
            ⚡ Vantagens
          </Typography>
          <Box component="ul" sx={{ mt: 1, pl: 2 }}>
            <li><Typography variant="body2">Agendamento 24/7 sem intervenção manual</Typography></li>
            <li><Typography variant="body2">Visualização de horários disponíveis em tempo real</Typography></li>
            <li><Typography variant="body2">Confirmação automática por e-mail</Typography></li>
            <li><Typography variant="body2">Interface responsiva (desktop, tablet e mobile)</Typography></li>
          </Box>
        </Alert>

        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2" gutterBottom fontWeight="medium">
            Link público da agenda
          </Typography>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{
              readOnly: true,
              sx: { 
                fontFamily: 'monospace',
                fontSize: '0.9rem',
                bgcolor: 'grey.50',
              }
            }}
            onClick={(e) => e.target.select()}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button onClick={onClose}>
          Fechar
        </Button>
        <Button
          variant="outlined"
          startIcon={<OpenInNewIcon />}
          onClick={onOpen}
        >
          Abrir em nova janela
        </Button>
        <Button
          variant="contained"
          startIcon={<ContentCopyIcon />}
          onClick={onCopy}
        >
          Copiar Link
        </Button>
      </DialogActions>
    </Dialog>
  );
}
